export const findScrollableParent = (
  element: HTMLElement,
): HTMLElement | null => {
  if (element.assignedSlot) {
    return findScrollableParent(element.assignedSlot);
  }

  const parent: HTMLElement | null = element.parentElement;

  if (!parent) {
    if (element.getRootNode() instanceof ShadowRoot) {
      return findScrollableParent(
        (element.getRootNode() as ShadowRoot).host as HTMLElement,
      );
    }

    return null;
  }

  const hasScrollableContent = parent.scrollHeight > parent.clientHeight;
  const overflowYStyle = window.getComputedStyle(parent).overflowY;
  const isOverflowScrollable =
    overflowYStyle === 'auto' || overflowYStyle === 'scroll';

  if (hasScrollableContent && isOverflowScrollable) {
    return parent;
  }

  return findScrollableParent(parent);
};
